<template>
  <div class="el-imgbox" :style="`height:${treeHeight}px;`">
    <!-- 锅炉 -->
    <div style="left: 20%; top:20%;width:200px;height:30px; position: absolute;" @click="handleClick(1)">
      <div class="ref1" @mouseenter="enter('1')" @mouseleave="leave('1')">
        <img src="../../../public/static/vince/images/kongtiao/boiler.svg" style="width: 51px; height: 70px;" alt="">
      </div>
      <div class="hoverMsg hover1" v-if="showInfo1">
        锅炉#1
      </div>
    </div>
    <div style="left: 15%; top:40%;width:200px;height:30px; position: absolute;" @click="handleClick(1)">
      <div class="ref1" @mouseenter="enter('2')" @mouseleave="leave('2')">
        <img src="../../../public/static/vince/images/kongtiao/boiler.svg" style="width: 51px; height: 70px;" alt="">
      </div>
      <div class="hoverMsg hover1" v-if="showInfo2">
        锅炉#2
      </div>
    </div>
    <div style="left: 10%; top:70%;width:200px;height:30px; position: absolute;" @click="handleClick(1)">
      <div class="ref1" @mouseenter="enter('3')" @mouseleave="leave('3')">
        <img src="../../../public/static/vince/images/kongtiao/boiler.svg" style="width: 51px; height: 70px;" alt="">
      </div>
      <div class="hoverMsg hover1" v-if="showInfo3">
        锅炉#3
      </div>
    </div>
    <!-- 热水循环泵 -->
    <div style="left: 40%; top:22%;width:200px;height:30px; position: absolute;" @click="handleClick(2)">
      <div class="ref1" @mouseenter="enter('4')" @mouseleave="leave('4')">
        <img src="../../../public/static/vince/images/kongtiao/hot_water_loop_pump.svg"
          style="width: 51px; height: 70px;" alt="">
      </div>
      <div class="hoverMsg hover2" v-if="showInfo4">
        <p style="line-height: 42px;">热水循坏泵#1</p>
        <p style="margin-top: -37px;color: #ff6e00;">42.61°C</p>
      </div>
    </div>
    <div style="left: 40%; top:40%;width:200px;height:30px; position: absolute;" @click="handleClick(2)">
      <div class="ref1" @mouseenter="enter('5')" @mouseleave="leave('5')">
        <img src="../../../public/static/vince/images/kongtiao/hot_water_loop_pump.svg"
          style="width: 51px; height: 70px;" alt="">
      </div>
      <div class="hoverMsg hover2" v-if="showInfo5">
        <p style="line-height: 42px;">热水循坏泵#2</p>
        <p style="margin-top: -37px;color: #ff6e00;">42.61°C</p>
      </div>
    </div>
    <div style="left: 40%; top:50%;width:200px;height:30px; position: absolute;" @click="handleClick(2)">
      <div class="ref1" @mouseenter="enter('6')" @mouseleave="leave('6')">
        <img src="../../../public/static/vince/images/kongtiao/hot_water_loop_pump.svg"
          style="width: 51px; height: 70px;" alt="">
      </div>
      <div class="hoverMsg hover2" v-if="showInfo6">
        <p style="line-height: 42px;">热水循坏泵#3</p>
        <p style="margin-top: -37px;color: #ff6e00;">42.61°C</p>
      </div>
    </div>
    <div style="left: 40%; top:66%;width:200px;height:30px; position: absolute;" @click="handleClick(2)">
      <div class="ref1" @mouseenter="enter('7')" @mouseleave="leave('7')">
        <img src="../../../public/static/vince/images/kongtiao/hot_water_loop_pump.svg"
          style="width: 51px; height: 70px;" alt="">
      </div>
      <div class="hoverMsg hover2" v-if="showInfo7">
        <p style="line-height: 42px;">热水循坏泵#4</p>
        <p style="margin-top: -37px;color: #ff6e00;">42.61°C</p>
      </div>
    </div>
    <!-- 暖源分水器 -->
    <div style="left: 75%; top:30%;width:200px;height:30px; position: absolute;" @click="handleClick(3)">
      <div class="ref1" @mouseenter="enter('8')" @mouseleave="leave('8')">
        <img src="../../../public/static/vince/images/kongtiao/manifold.svg" style="width: 51px; height: 70px;" alt="">
      </div>
      <div class="hoverMsg hover3" v-if="showInfo8">
        <p style="line-height: 42px;">暖源分水器#1</p>
        <p style="margin-top: -37px;color: #ff6e00;">42.61°C 1282Mpa</p>
      </div>
    </div>
    <div style="left: 77%; top:60%;width:200px;height:30px; position: absolute;" @click="handleClick(3)">
      <div class="ref1" @mouseenter="enter('9')" @mouseleave="leave('9')">
        <img src="../../../public/static/vince/images/kongtiao/manifold.svg" style="width: 51px; height: 70px;" alt="">
      </div>
      <div class="hoverMsg hover3" v-if="showInfo9">
        <p style="line-height: 42px;">暖源分水器#2</p>
        <p style="margin-top: -37px;color: #ff6e00;">42.61°C 1282Mpa</p>
      </div>
    </div>
    <el-dialog title="锅炉" :visible.sync="Visible1" width="600px" :close-on-click-modal='false' center>
      <div style="float: left;">
        <img width="180px" src="../../../public/static/vince/images/kongtiao/guolu.png" alt="">
      </div>
      <div class="info" style="display: flex;flex-direction: row;padding-left: 10px;">
        <div style="width: 50%;float: left;line-height: 27px;display: flex;flex-direction: column">
          <span>设备编号：GL0001</span>
          <span>启停状态：开启</span>
          <span>手自动状态：手动</span>
          <span>出水压力：106pa</span>
        </div>
        <div style="width: 50%;float: left;line-height: 27px;display: flex;flex-direction: column">
          <span>位置：锅炉#</span>
          <span>故障状态：正常</span>
          <span>功率：7.5KW</span>
        </div>
      </div>
      <div class="footInfo" style="display: flex;flex-direction: column;padding-left: 10px;">
        <div style="display: flex;flex-direction: row;">
          <div class="f-left">
            <span>Uab</span>
          </div>
          <div class="f-right">
            <span>288</span>
          </div>
          <div class="f-left">
            <span>Ubc</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
          <div class="f-left">
            <span>Uca</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
        </div>
        <div style="display: flex;flex-direction: row;">
          <div class="f-left">
            <span>Ua</span>
          </div>
          <div class="f-right">
            <span>288</span>
          </div>
          <div class="f-left">
            <span>Ub</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
          <div class="f-left">
            <span>Uc</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
        </div>
        <div style="display: flex;flex-direction: row;">
          <div class="f-left">
            <span>La</span>
          </div>
          <div class="f-right">
            <span>288</span>
          </div>
          <div class="f-left">
            <span>Lb</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
          <div class="f-left">
            <span>Lc</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="热水循坏泵" :visible.sync="Visible2" width="600px" :close-on-click-modal='false' center>
      <div style="float: left;">
        <img width="180px" src="../../../public/static/vince/images/kongtiao/lengqubeng.png" alt="">
      </div>
      <div class="info" style="display: flex;flex-direction: row;padding-left: 10px;">
        <div style="width: 50%;float: left;line-height: 27px;display: flex;flex-direction: column">
          <span>设备编号：GL0001</span>
          <span>启停状态：开启</span>
          <span>手自动状态：手动</span>
          <span>出水压力：106pa</span>
        </div>
        <div style="width: 50%;float: left;line-height: 27px;display: flex;flex-direction: column">
          <span>位置：热水循坏泵#</span>
          <span>故障状态：正常</span>
          <span>功率：7.5KW</span>
        </div>
      </div>
      <div class="footInfo" style="display: flex;flex-direction: column;padding-left: 10px;">
        <div style="display: flex;flex-direction: row;">
          <div class="f-left">
            <span>Uab</span>
          </div>
          <div class="f-right">
            <span>288</span>
          </div>
          <div class="f-left">
            <span>Ubc</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
          <div class="f-left">
            <span>Uca</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
        </div>
        <div style="display: flex;flex-direction: row;">
          <div class="f-left">
            <span>Ua</span>
          </div>
          <div class="f-right">
            <span>288</span>
          </div>
          <div class="f-left">
            <span>Ub</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
          <div class="f-left">
            <span>Uc</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
        </div>
        <div style="display: flex;flex-direction: row;">
          <div class="f-left">
            <span>La</span>
          </div>
          <div class="f-right">
            <span>288</span>
          </div>
          <div class="f-left">
            <span>Lb</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
          <div class="f-left">
            <span>Lc</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="暖源分水器" :visible.sync="Visible3" width="600px" :close-on-click-modal='false' center>
      <div style="float: left;">
        <img width="180px" src="../../../public/static/vince/images/kongtiao/lengyuanjishui.jpg" alt="">
      </div>
      <div class="info" style="display: flex;flex-direction: row;padding-left: 10px;">
        <div style="width: 50%;float: left;line-height: 27px;display: flex;flex-direction: column">
          <span>设备编号：GL0001</span>
          <span>启停状态：开启</span>
          <span>手自动状态：手动</span>
          <span>出水压力：106pa</span>
        </div>
        <div style="width: 50%;float: left;line-height: 27px;display: flex;flex-direction: column">
          <span>位置：暖源分水器#</span>
          <span>故障状态：正常</span>
          <span>功率：7.5KW</span>
        </div>
      </div>
      <div class="footInfo" style="display: flex;flex-direction: column;padding-left: 10px;">
        <div style="display: flex;flex-direction: row;">
          <div class="f-left">
            <span>Uab</span>
          </div>
          <div class="f-right">
            <span>288</span>
          </div>
          <div class="f-left">
            <span>Ubc</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
          <div class="f-left">
            <span>Uca</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
        </div>
        <div style="display: flex;flex-direction: row;">
          <div class="f-left">
            <span>Ua</span>
          </div>
          <div class="f-right">
            <span>288</span>
          </div>
          <div class="f-left">
            <span>Ub</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
          <div class="f-left">
            <span>Uc</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
        </div>
        <div style="display: flex;flex-direction: row;">
          <div class="f-left">
            <span>La</span>
          </div>
          <div class="f-right">
            <span>288</span>
          </div>
          <div class="f-left">
            <span>Lb</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
          <div class="f-left">
            <span>Lc</span>
          </div>
          <div class="f-right">
            <span>0</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        Visible1: false,
        Visible2: false,
        Visible3: false,
        treeHeight: '',
        showInfo1: true,
        showInfo2: true,
        showInfo3: true,
        showInfo4: true,
        showInfo5: true,
        showInfo6: true,
        showInfo7: true,
        showInfo8: true,
        showInfo9: true,
      }
    },
    methods: {
      handleClick(item) {
        if (item == 1) {
          this.Visible1 = true;
        } else if (item == 2) {
          this.Visible2 = true;
        } else if (item == 3) {
          this.Visible3 = true;
        }
      },
    //   enter(item) {
    //     if (item == '1') {
    //       this.showInfo1 = true;
    //     } else if (item == '2') {
    //       this.showInfo2 = true;
    //     } else if (item == '3') {
    //       this.showInfo3 = true;
    //     } else if (item == '4') {
    //       this.showInfo4 = true;
    //     } else if (item == '5') {
    //       this.showInfo5 = true;
    //     } else if (item == '6') {
    //       this.showInfo6 = true;
    //     } else if (item == '7') {
    //       this.showInfo7 = true;
    //     } else if (item == '8') {
    //       this.showInfo8 = true;
    //     } else if (item == '9') {
    //       this.showInfo9 = true;
    //     }
    //   },
    //   leave(item) {
    //     if (item == '1') {
    //       this.showInfo1 = false;
    //     } else if (item == '2') {
    //       this.showInfo2 = false;
    //     } else if (item == '3') {
    //       this.showInfo3 = false;
    //     } else if (item == '4') {
    //       this.showInfo4 = false;
    //     } else if (item == '5') {
    //       this.showInfo5 = false;
    //     } else if (item == '6') {
    //       this.showInfo6 = false;
    //     } else if (item == '7') {
    //       this.showInfo7 = false;
    //     } else if (item == '8') {
    //       this.showInfo8 = false;
    //     } else if (item == '9') {
    //       this.showInfo9 = false;
    //     }
    //   }
    },

    mounted() {
      window.onresize = () => {
        this.treeHeight = document.documentElement.clientHeight - 103;
      }
      this.treeHeight = document.documentElement.clientHeight - 103;
    }
  }

</script>
<style scoped>
  .el-imgbox {
    width: 100%;
    height: 100%;
    background: url('../../../public/static/vince/images/kongtiao/hot.png') center center no-repeat;
    background-size: 100% 100%;
	position: relative;
  }
  .ref1 {
    background-color: #B4B4B4;
    box-shadow: 0px 0px 4px #818181;
    width: 70px;
    height: 67px;
    float: left;
    line-height: 30px;
    text-align: left;
    padding-left: 8px;
    cursor: pointer;
  }

  .hoverMsg {
    height: 67px;
    text-align: center;
    line-height: 66px;
    font-size: 15px;
	font-family: PingFangSC-Regular;
	color: #fff;
  }
  .hoverMsg:hover{
	cursor: pointer;
  }

  .hover1 {
    width: 180px;
  }

  .hover2 {
    width: 230px;
  }

  .hover3 {
    width: 235px;
  }

  .f-left {
    width: 38px;
    height: 27px;
    line-height: 27px;
    text-align: center;
    background: rgba(89, 161, 255, 0.39);
    border-left: 1px;
    border-top: 1px;
    border-bottom: 1px
  }

  .f-right {
    width: 62px;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    padding-left: 7px;
    color: #fff;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

</style>
